import React from "react";
import styled from "styled-components";
import { Outlet } from "react-router-dom";
import DashboardSideNav from "../DashboardSideNav";

import Drawer from "../Drawer";
import { DashboardHeader } from "../Headers";

const DashboardLayoutStyle = styled.main`
  background: #fafafa;
  min-height: 100vh;
`;

export const DashboardLayout = ({ children }) => {
  return (
    <DashboardLayoutStyle>
      <div className="md:hidden">
        <Drawer />
      </div>
      <DashboardHeader />
      <div className="flex">
        <DashboardSideNav />
        <div className="flex-1 p-4">
          <Outlet />
        </div>
      </div>
    </DashboardLayoutStyle>
  );
};
